import { useAuth0 } from "@auth0/auth0-react";
import { Checkbox } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import OpenInNewOutlinedIcon from "@mui/icons-material/OpenInNewOutlined";
import IndeterminateCheckBoxOutlinedIcon from "@mui/icons-material/IndeterminateCheckBoxOutlined";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import FinanceService from "Lib/API/Finance";
import FinanceSettingService from "Lib/API/FinanceSetting/FinanceSetting";
import { InputField, LabelField, MyCheckbox } from "components";
import Action from "components/ActionPopOver";
import AlertDialog from "components/Dialog";
import MainDialog from "components/Dialog/MainDialog";
import MyModal from "components/MyModal";
import Loader from "components/loader/Loader";
import { formatDate, numberFormat } from "helper";
import { getDateFormatForDatePicket } from "helper/dateFormat.js";
import { useDisableEnterKey } from "hook";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import React, { memo, useEffect, useRef, useState } from "react";
import { toastr } from "react-redux-toastr";
import Select from "react-select";
import styled from "styled-components";
import * as XLSX from "xlsx";
import { sanitizeRows } from "utils/exportSanitize";
import { DateFormetContext } from "../../../../app/App.js";
import { CheckFloatValue } from "../../../../utils/functions";
import { downloadFile, uploadFile } from "../../../Auth/Presigned";
import "../../index.scss";

const Button = styled.button`
  width: 170px;
  height: 48px;
`;
const CancelButton = styled(Button)`
  background: #ffffff;
  border: 1px solid #2555ef;
  border-radius: 5px;
  color: #2555ef;
`;
const SpanHeader = styled.span`
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
`;
export const ExpandTablePendding = (props) => {
  const {
    row,
    hide,
    setHide,
    prevType,
    depositID,
    onCheckboxChange,
    check,
    setDrawerData,
    setOpenModal,
    syncModal,
    setSyncModal,
    handleData,
    newDepositData,
    createNewDeposit,
    getQuickBooksURL,
    setPendingBatchType,
    isLoading,
    transactionsNumber,
    amount,
    pendingType,
    fetchMyAPI,
    type,
    filters,
    transactionNumber,
    setStartDate,
    start_date,
  } = props;




  const handleSelect = (dates) => {
    console.log(dates, "dates");
    setStartDate(dates);
  };

  const { getAccessTokenSilently } = useAuth0();
  const [disabled, setDisable] = useState(true);

  const [bankAccountList, setBankAccountList] = React.useState([]);

  const [open, setOpen] = React.useState(false);

  const [shareLoading, setShareLoading] = useState(false);

  const [reversalActionTypes, setReversalActionTypes] = useState(false);
  const handleCloseDialog = () => {
    setReversalActionTypes(false);
  };

  const generateExcel = (data) => {
    // console.log(data);
    let res = data?.transactions?.map((item) => {
      return {
        Id: item?._id,
        Account: item?.Account?.name,
        Amount: numberFormat({number:data?.type === "payment" ? item?.amount : item.charge?.amount, decimal:2, style: 'currency'}),
        Ledger: item?.Ledger?.name,
        SubLedger: item?.SubLedger?.name,
        Bank_Account: item?.bank_account?.title,
        // Charge_type: item?.charge_type,
        Date: item?.date,
        CreatedAt: item?.createdAt,
        Method:
          data?.type === "payment"
            ? item?.charge?.payment?.History?.paymnetMethod?.method
            : "",
        Number:
          data?.type === "payment"
            ? item?.charge?.payment?.History?.paymnetMethod?.check_number
            : "",
      };
    });
    const worksheet = XLSX.utils.json_to_sheet(sanitizeRows(res));
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, "DataSheet2.xlsx");
  };
  const customStyles = {
    control: () => ({
      backgroundColor: "#F3F6F9",
      border: "none",
      borderRadius: "6px",
      height: "48px",
      width: "100%",
      display: "flex",
    }),
  };
  const Unbatch = async (id) => {
    const token = await getAccessTokenSilently();
    await FinanceService.Unbatch(id, token)
      .then((res) => {
        toastr.success("Success", "Unbatch sucsess");
        fetchMyAPI();
      })
      .catch((e) => {
        fetchMyAPI();

        toastr.error("Error", e?.data?.message ?? "Something went wrong");
      });
  };

  const Undeposit = async (id) => {
    const token = await getAccessTokenSilently();
    await FinanceService.Undeposit(id, token)
      .then((res) => {
        toastr.success("Success", "Undeposit sucsess");
        setSyncModal(false);
        fetchMyAPI();
      })
      .catch((e) => {
        setSyncModal(false);
        fetchMyAPI();
        toastr.error("Error", e?.data?.message ?? "Something went wrong");
      });
  };

  const markAsBatchedSynced = async (id) => {
    const token = await getAccessTokenSilently();
    await FinanceService.markAsBatchedSynced(id, token)
      .then((res) => {
        toastr.success("Success", "Marked as synced");
        setSyncModal(false);
        fetchMyAPI();
      })
      .catch((e) => {
        setSyncModal(false);
        toastr.error("Error", e?.data?.message ?? "Something went wrong");
      });
  }

  const [depositDetails, setDepositDetails] = useState({});
  const [depositDetailsOpen, setDepositDetailsOpen] = useState(false);

  const getDepositDetailsForExcel = async (row) => {
    const token = await getAccessTokenSilently();
    await FinanceService.getDepositDetails(row?._id, token)
      .then((res) => {
        console.log(res, "res");
        setDepositDetails(res?.result);
        generateDepositeExcel(row, res?.result);
      })
      .catch((e) => {
        toastr.error("Error", e?.data?.message ?? "Something went wrong");
      });
  };

  const generateDepositeExcel = async (row, depositDetails) => {
    // if (depositDetails?.batches?.length === 0) return;
    let datas = [];
    const theType = depositDetails?.type;
    let res = depositDetails?.batches?.map((batch) => {
      // eslint-disable-next-line no-unused-expressions
      batch?.transactions?.map((item) => {
        datas = [
          ...datas,
          {
            Amount: numberFormat({number:theType === "charge" ? item?.charge?.amount : item?.amount, decimal:2, style: 'currency'}),
            Ledger: item?.Ledger?.name,
            SubLedger: item?.SubLedger?.name,
            Account_Receiveable: item?.Ledger?.account_receivable,
            Bank_Account: item?.bank_account?.title,
            Transaction_Id: item?._id,
            Name: item?.Account?.name,
            Date: formatDate({date:item?.date, formatType: "defaultWithTimeUTC"}),
            CreatedAt: formatDate({date:item?.createdAt, formatType: "defaultWithTimeUTC"}),
            Payment_Method:
              item?.charge?.payment?.History[0]?.paymnetMethod?.method,
          },
        ];
      });
    });
    console.log("datas: ", datas);

    const worksheet = XLSX.utils.json_to_sheet(sanitizeRows(datas));
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, "Synced Batches.xlsx");
  };

  const getDepositDetailsForShare = async (row) => {
    setShareLoading(true);
    const token = await getAccessTokenSilently();
    await FinanceService.getDepositDetails(row?._id, token)
      .then((res) => {
        console.log(res, "res");
        setDepositDetails(res?.result);
      })
      .catch((e) => {
        toastr.error("Error", e?.data?.message ?? "Something went wrong");
      });
    setDepositDetailsOpen(true);
    shareDepositePdf(row);
    setShareLoading(false);
  };

  const inputRef = useRef(null);
  console.log("inputRef: ", inputRef);
  const shareDepositePdf = async (row) => {
    console.log("row: ", row);
    setOpen(true);
    const token = await getAccessTokenSilently();
    html2canvas(inputRef.current)
      .then(async (canvas) => {
        let width = -105;
        let height = -100;
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF();
        pdf.addImage(imgData, "PNG", 10, 10, width, height);
        var out = pdf.output("blob");

        const convertedfile = new File([out], {
          type: "application/pdf",
          name: "invoiceDoc",
        });

        var splitedImgData = imgData.split(",")[1];
        var binary_string = window.atob(splitedImgData);
        var len = binary_string.length;
        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
          bytes[i] = binary_string.charCodeAt(i);
        }
        if (imgData) {
          let newURL = await uploadFile(bytes.buffer, convertedfile, token);

          let downloadLink = await downloadFile(newURL.fileName, token);
          let downloadURL = downloadLink.link;
          window.location = `mailto:${""}?subject= ${`${row?.title}-${row?._id}` ?? ""
            }&body= Here is the link to download document - ${encodeURIComponent(
              downloadURL
            )}`;
        }
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message);
      });
  };


  useDisableEnterKey(true);


  const depositDetailsDownload = () => {
    return (
      <div>
        <Table ref={inputRef}>
          <TableRow>
            <TableCell style={{ padding: 0 }} colSpan={10}>
              {/* <Box> */}
              {/* <Typography variant="h6" gutterBottom component="div" /> */}
              <Table size="small" aria-label="purchases">
                <TableHead>
                  {/* <TableRow>
                  <TableCell style={{ paddingTop: 14, textAlign: "center" }} colSpan={10}>
                    <SpanHeader>Related Transactions</SpanHeader>
                  </TableCell>
                </TableRow> */}
                  <TableRow>
                    <TableCell align="left" variant="body">
                      <SpanHeader>{"amount".toUpperCase()}</SpanHeader>
                    </TableCell>
                    <TableCell align="left" variant="body">
                      <SpanHeader>
                        {"sub ledger / ledger".toUpperCase()}
                      </SpanHeader>
                    </TableCell>
                    <TableCell align="left" variant="body">
                      <SpanHeader>
                        {"account_receiveable".toUpperCase()}
                      </SpanHeader>
                    </TableCell>
                    <TableCell align="left" variant="body">
                      <SpanHeader>{"bank_account".toUpperCase()}</SpanHeader>
                    </TableCell>
                    <TableCell align="left" variant="body">
                      <SpanHeader>{"transaction#".toUpperCase()}</SpanHeader>
                    </TableCell>
                    <TableCell align="left" variant="body">
                      <SpanHeader>{"date".toUpperCase()}</SpanHeader>
                    </TableCell>
                    <TableCell align="left" variant="body">
                      <SpanHeader>{"created_at".toUpperCase()}</SpanHeader>
                    </TableCell>
                    <TableCell align="left" variant="body">
                      <SpanHeader>{"payment_method".toUpperCase()}</SpanHeader>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {depositDetails?.batches?.map((batch) => {
                    return batch?.transactions?.map((row) => (
                      <TableRow
                        key={row?._id}
                        className="MuiTableRow-root-temp"
                      >
                        <TableCell className="finance-table">
                          {" "}
                          <div className="finance-table transaction-led-sub table-row ">
                            <div className="sub">
                              {row?.charge?.amount ?? "-"}
                            </div>
                          </div>{" "}
                        </TableCell>
                        <TableCell className="finance-table">
                          {" "}
                          <div className="finance-table transaction-led-sub table-row ">
                            <div className="sub">
                              {row?.Ledger?.name ? row?.Ledger?.name : "-"}
                            </div>
                            <div className="led">
                              {row?.SubLedger?.name
                                ? row?.SubLedger?.name
                                : "-"}
                            </div>
                          </div>{" "}
                        </TableCell>
                        <TableCell className="finance-table">
                          {" "}
                          <div className="finance-table transaction-led-sub table-row ">
                            <div className="sub">
                              {row?.Ledger?.account_receivable ?? "-"}
                            </div>
                          </div>{" "}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          className="charged-cell"
                        >
                          <div className="transaction-charged table-row">
                            {row?.bank_account?.title ?? "-"}
                          </div>
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          className="charged-cell"
                        >
                          {" "}
                          <div className="transaction-charged table-row">
                            {row?._id}
                          </div>
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          className="charged-cell"
                        >
                          {" "}
                          <div className="transaction-charged table-row">
                            {formatDate({date:row?.date, formatType: "defaultWithTimeUTC"})}
                          </div>
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          className="charged-cell"
                        >
                          {" "}
                          <div className="transaction-charged table-row">
                            {formatDate({date:row?.createdAt, formatType: "defaultWithTimeUTC"})}
                          </div>
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          className="charged-cell"
                        >
                          {" "}
                          <div className="transaction-charged table-row">
                            {row?.charge?.payment?.History[0]?.paymnetMethod
                              ?.method ?? "-"}
                          </div>
                        </TableCell>
                      </TableRow>
                    ));
                  })}
                </TableBody>
              </Table>
              {/* </Box> */}
            </TableCell>
          </TableRow>
        </Table>
      </div>
    );
  };

  const getCommaSeperatedValue = (num) => {
    return (
      CheckFloatValue(num)
        ?.toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",") ?? 0.0
    );
  };

  const localStorageData = localStorage.getItem("organization")
    ? JSON.parse(localStorage.getItem("organization"))
    : null;



  const [enableLoading, SetIsLoading] = useState(false);

  const handleSyncMark = async (Id) => {
    const token = await getAccessTokenSilently();
    SetIsLoading(true);
    await FinanceService.markSynced(Id, token)
      .then((res) => {
        SetIsLoading(false);
        if (res) {
          setSyncModal(false);
          fetchMyAPI();
        }
      })
      .catch((e) => {
        SetIsLoading(false);
        toastr.error("Error", e?.data?.message ?? "Something went wrong");
      });
  };

  return (
    <React.Fragment>
 
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        {type !== "Deposited" && (
          <TableCell
            className="main-check"
            style={{
              pointerEvents:
                disabled &&
                  prevType &&
                  !prevType?.some((item) => item.type === row?.type) &&
                  check.length >= 1
                  ? "none"
                  : "initial",
            }}
          >
            <MyCheckbox
              // color="primary"
              color="default"
              handlechange={(e) => onCheckboxChange(e, row)}
              checked={
                !!(
                  check?.includes(row?._id) &&
                  prevType?.some((item) => item.type === row?.type)
                )
                // check?.includes(row?._id)
              }
              onClick={() => setPendingBatchType(row?.type)}
            />
          </TableCell>
        )}
        {row.transactions?.length >= 1 ? (
          <TableCell>
            <IconButton
              aria-label="expand ro w"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? (
                <IndeterminateCheckBoxOutlinedIcon
                  style={{ height: "29px", width: "29px" }}
                />
              ) : (
                <AddBoxOutlinedIcon style={{ height: "29px", width: "29px" }} />
              )}
            </IconButton>
          </TableCell>
        ) : (
          <TableCell />
        )}
        <TableCell
          align="left"
          onClick={() => {
            setDrawerData(row);
            setOpenModal(true);
          }}
          className="batch#"
          style={{
            width: "230px",
            minWidth: "230px",
            maxWidth: "230px",
          }}
        >
          <div className="transaction-led-sub table-row" title={row?._id}>
            <p className="sub">{row?._id ? row?._id : "-"}</p>
          </div>
        </TableCell>
        <TableCell
          align="left"
          onClick={() => {
            setDrawerData(row);
            setOpenModal(true);
          }}
        >
          <div className="transaction-account-name ">
            {numberFormat({number:row?.amount, decimal:2, style: 'currency'})}
          </div>
        </TableCell>
        <TableCell
          align="left"
          onClick={() => {
            setDrawerData(row);
            setOpenModal(true);
          }}
        >
          <div className="transaction-account-name ">
            {getCommaSeperatedValue(row?.type ?? "-")}
          </div>
        </TableCell>
        {pendingType === "Pending" && (
          <TableCell
            align="left"
            onClick={() => {
              setDrawerData(row);
              setOpenModal(true);
            }}
          >
            <div className="transaction-trans table-row">
              <div className="led">
                {row?.bank_account?.title ? row?.bank_account?.title : "-"}
              </div>
            </div>
          </TableCell>
        )}

        {pendingType === "Pending" && (
          <TableCell
            align="left"
            onClick={() => {
              setDrawerData(row);
              setOpenModal(true);
            }}
          >
            <div className="transaction-trans table-row">
              <div className="led">
                {row?._id ? row?._id : "-"}
              </div>
            </div>{" "}
          </TableCell>
        )}

        <TableCell
          align="left"
          onClick={() => {
            setDrawerData(row);
            setOpenModal(true);
          }}
        >
          <div className="transaction-trans table-row">
            {row.title ? row.title : "-"}
          </div>{" "}
        </TableCell>
        {/* )} */}

        <TableCell
          align="left"
          onClick={() => {
            setDrawerData(row);
            setOpenModal(true);
          }}
        >
          <div className="transaction-trans table-row">
            {row.date
              ? formatDate({date:row?.date, formatType: "defaultWithTimeUTC"})
              : "-"}
          </div>{" "}
        </TableCell>
        {pendingType === "Deposited" && (
          <TableCell
            align="left"
            onClick={() => {
              setDrawerData(row);
              setOpenModal(true);
            }}
          >
            <div className="transaction-trans table-row">
              {row?.isSynced ? "true" : "false"}
            </div>{" "}
          </TableCell>
        )}

        <TableCell className="icon-cell sticky-body-column">
          {/* {check?.length === 0 && ( */}
          <div style={{ cursor: "pointer", paddingleft: "0px" }}>
            <Action
              style={{ width: "16px" }}
              action={pendingType === "Pending" ? "pending" : "deposits"}
              generateExcel={() => generateExcel(row)}
              Unbatch={() => Unbatch(row?._id)}
              Undeposit={() => Undeposit(row?._id)}
              markAsBatchedSynced={() => markAsBatchedSynced(row?._id)}
              markAsSynced={() => {
                handleSyncMark(row?._id);
              }}
              generateDepositeExcel={() => getDepositDetailsForExcel(row)}
              shareDepositePdf={() => getDepositDetailsForShare(row)}
              shareLoading={shareLoading}
              check={check}
              row={row}
            />
          </div>
          {/* )} */}

          <MainDialog
            open={reversalActionTypes}
            // getTypes={getTypes}
            handleClose={handleCloseDialog}
            onDecline={() => {
              setReversalActionTypes(false);
            }}
            content={"Choose A Reversal Type from Existing Types !!"}
          />
        </TableCell>
      </TableRow>
      {
        open && (
          <TableRow>
            <TableCell style={{ padding: 0 }} colSpan={10}>
              <Collapse in={open} timeout="auto" unmountOnExit>
                {/* <Box> */}
                {/* <Typography variant="h6" gutterBottom component="div" /> */}
                <Table size="small" aria-label="purchases">
                  <TableHead>
                    <TableRow>
                      <TableCell />

                      <TableCell style={{ paddingTop: 14 }} colSpan={10}>
                        <SpanHeader>Related Transactions</SpanHeader>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell variant="body" />
                      {type == 'Pending' ? <TableCell variant="body" /> : null}
                      {type == 'Pending' ? (
                        <TableCell variant="body">
                          <SpanHeader>{'created date'.toUpperCase()}</SpanHeader>
                        </TableCell>
                      ) : null}
                      {type == "Pending" ? (
                        <TableCell variant="body">
                          <SpanHeader>{"due date".toUpperCase()}</SpanHeader>
                        </TableCell>
                      ) : null}
                      {type == "Pending" ? (
                        <TableCell align="left" variant="body">
                          <SpanHeader>{'Acoount Name'.toUpperCase()}</SpanHeader>
                        </TableCell>
                      ) : null}
                      <TableCell align="left" variant="body">
                        <SpanHeader>{'amount'.toUpperCase()}</SpanHeader>
                      </TableCell>
                      <TableCell align="left" variant="body">
                        <SpanHeader>
                          {'sub ledger / ledger'.toUpperCase()}
                        </SpanHeader>
                      </TableCell>
                      <TableCell align="left" variant="body">
                        <SpanHeader>
                          {'payment date'.toUpperCase()}
                        </SpanHeader>
                      </TableCell>
                      <TableCell align="left" variant="body">
                        <SpanHeader>{'bank account'.toUpperCase()}</SpanHeader>
                      </TableCell>
                      {type == 'Pending' ? (
                        <TableCell align="left" variant="body">
                          <SpanHeader>{'transaction#'.toUpperCase()}</SpanHeader>
                        </TableCell>
                      ) : null}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {row.transactions.map((item) => (
                      <TableRow key={item.id} className="MuiTableRow-root-temp">
                        <TableCell
                          className="checkbox-cell"
                          component="td"
                          scope="row"
                          variant="body"
                        />
                        {type == 'Pending' ? (
                          <TableCell
                            className="checkbox-cell"
                            component="td"
                            scope="row"
                            variant="body"
                          >
                            <div
                              className="status"
                              style={
                                item?.charge?.status.toUpperCase() ===
                                  "CHARGE".toUpperCase()
                                  ? { color: "#FBA12C" }
                                  : item?.charge?.status.toUpperCase() ===
                                    "payment".toUpperCase()
                                    ? { color: "#81DC91" }
                                    : {}
                              }
                            >
                              <span>{item?.charge?.status.toUpperCase()}</span>
                            </div>
                          </TableCell>
                        ) : null}

                        {type == 'Pending' ? (
                          <TableCell
                            component="th"
                            scope="row"
                            className="date-cell"
                          >
                            <div className="transaction-led-sub table-row">
                              {formatDate({date:item?.charge?.createdAt, formatType: "defaultWithUTC"})}
                            </div>
                          </TableCell>
                        ) : null}
                        {type == 'Pending' ? (
                          <TableCell
                            component="th"
                            scope="row"
                            className="date-cell"
                          >
                            <div className="transaction-led-sub table-row">
                              {formatDate({date:item?.charge?.due_date, formatType: "defaultWithUTC"})}
                            </div>
                          </TableCell>
                        ) : null}
                        {type == "Pending" ? (
                          <TableCell
                            component="th"
                            scope="row"
                            className="finance-table"
                          >
                            <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                              <div className="transaction-account-name ellipsDueAmount">{item?.Account?.name}</div>
                              {(item?.Account?.id ?? item?.Account?._id) && (
                                <a
                                  href={`/member-details/${item?.Account?.id ?? item?.Account?._id}`}
                                  target="_blank"
                                  rel="noreferrer"
                                  onClick={(e) => e.stopPropagation()}
                                  style={{ display: "flex", alignItems: "center", color: "#2555EF", flexShrink: 0 }}
                                >
                                  <OpenInNewOutlinedIcon style={{ fontSize: 10, width: 18, height: 18 }} />
                                </a>
                              )}
                            </div>
                          </TableCell>
                        ) : null}
                        <TableCell
                          component="th"
                          scope="row"
                          className="charged-cell"
                        >
                          {' '}
                          <div className="transaction-charged table-row">
                            {numberFormat({number:
                              type == 'Pending'
                                ? row?.type === 'payment'
                                  ? item?.amount
                                  : item.charge?.amount
                                : item?.total
                            , decimal:2, style: 'currency'})}
                          </div>
                        </TableCell>
                        <TableCell className="finance-table">
                          {' '}
                          <div className="finance-table transaction-led-sub table-row ">
                            <div className="sub">
                              {item?.Ledger?.name ? item?.Ledger?.name : '-'}
                            </div>
                            <div className="led">
                              {item?.SubLedger?.name
                                ? item?.SubLedger?.name
                                : '-'}
                            </div>
                          </div>{' '}
                        </TableCell>
                        <TableCell className="finance-table">
                          {' '}
                          <div className="finance-table transaction-led-sub table-row ">
                            <div className="sub">
                              {row?.type?.includes("payment") ? 
                                formatDate({date:item?.charge?.payment?.History?.created_at, formatType: "defaultWithUTC"})
                              : '-'}
                            </div>
                          </div>{' '}
                        </TableCell>
                        <TableCell className="finance-table">
                          {' '}
                          <div className="finance-table transaction-led-sub table-row ">
                            <div className="sub">
                              {item?.bank_account?.title ?? '-'}
                            </div>
                          </div>{' '}
                        </TableCell>
                        {type == 'Pending' ? (
                          <TableCell className="ledger-cell">
                            <div className="transaction-charged table-row">
                              {item?._id ?? ''}
                            </div>
                          </TableCell>
                        ) : null}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
                {/* </Box> */}
              </Collapse>
            </TableCell>
          </TableRow>
        )
      }

      {/* handle new modal pop up */}

      {/* <div style={{ position: 'relative', visibility: "hidden" }}>
        {depositDetailsDownload()}
      </div> */}
      <Dialog
        className={
          "new-charge-modal"
          //  "new-charge-modal-w modal-step-two "
        }
        // className="document-modal"
        open={depositDetailsOpen}
        onClose={() => {
          setDepositDetailsOpen(false);
        }}
      >
        {depositDetailsDownload()}
      </Dialog>
    </React.Fragment >
  );
};
